import { create } from "zustand"
import { escapeHTML } from "utils/escapeHtml"

/**
 * A script handed to the Query Console from elsewhere (the assistant's
 * "Open in Console"): the Console puts it in its editor when it next shows
 * the project, then clears it. Kept in memory only.
 */
export interface ConsoleHandoff {
  projectId: string
  script: string
  /** The saved query it is, or null for a script not saved yet. */
  name: string | null
}

interface ConsoleHandoffState {
  pending: ConsoleHandoff | null
  handOff: (handoff: ConsoleHandoff) => void
  clear: () => void
}

export const useConsoleHandoffStore = create<ConsoleHandoffState>()((set) => ({
  pending: null,
  handOff: (handoff) => set({ pending: handoff }),
  clear: () => set({ pending: null }),
}))

/** The editor's content for `script`: one paragraph per line, as the Console loads a saved query. */
export const scriptToEditorHtml = (script: string): string =>
  script
    .split(/\r?\n/)
    .map((line) => `<p>${escapeHTML(line)}</p>`)
    .join("")
